export const validation = {
  maxTitleChar: 60,
  maxParagraphChar: 150
}
